import { showPrysmBadge } from 'src/utils'
import ContentStack from 'src/api/contentStack'
import './PrysmBadge.scss'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import React from 'react'

async function FetchMysiteTranslationContent(badgeUid) {
  try {
    const locale =
      getLocaleCodeFromUrl()?.split('_')?.reverse()?.join('-') || 'US-en'
    const csData = await ContentStack.getEntry('prysm_badge', locale, true)
    if (!csData?.entries || !Array.isArray(csData.entries)) {
      return { label: '', icon: '', link: '' }
    }

    const matchedEntry = csData.entries.find(entry => entry.uid === badgeUid)
    if (!matchedEntry) {
      return { label: '', icon: '', link: '' }
    }

    return {
      label: matchedEntry.label || '',
      icon:
        matchedEntry.icon?.[0]?.derivatives?.thumbnail ||
        matchedEntry.icon?.[0]?.derivatives?.webImage ||
        '',
      link: matchedEntry.link?.href || '',
    }
  } catch (error) {
    console.error('Error fetching Prysm badge from ContentStack:', error)
    return { label: '', icon: '', link: '' }
  }
}

class PrysmBadgeComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      contentStackData: null,
    }
  }

  componentDidMount() {
    this.loadContentStackData()
  }

  getPrysmBadge = () => {
    const { product } = this.props
    if (!product || typeof product !== 'object') return null

    let prysmBadge =
      product?.sku?.[0]?.properties?.prysmData ||
      product?.sku?.[0]?.skuProperties?.prysmData ||
      null

    if (!prysmBadge) return null

    if (typeof prysmBadge === 'string') {
      try {
        prysmBadge = JSON.parse(prysmBadge)
      } catch (error) {
        console.error('Failed to parse prysmBadge JSON:', error)
        return null
      }
    }

    return prysmBadge
  }

  loadContentStackData = async () => {
    const prysmBadge = this.getPrysmBadge()

    if (prysmBadge?.badgeUid) {
      const data = await FetchMysiteTranslationContent(prysmBadge.badgeUid)
      this.setState({ contentStackData: data })
    }
  }

  render() {
    const { contentStackData } = this.state

    if (!showPrysmBadge()) return <></>

    const prysmBadge = this.getPrysmBadge()
    if (!prysmBadge) return <></>

    const badgeData = contentStackData || prysmBadge
    const { icon = '', label = '', link = '' } = badgeData

    if (!icon || !label) return <></>

    const badgeLink = link?.trim() || '#'
    const isExternalLink = badgeLink !== '#'

    return (
      <div className="prysm-badge-wrapper">
        <a
          href={badgeLink}
          target={isExternalLink ? '_blank' : ''}
          rel={isExternalLink ? 'noopener noreferrer' : ''}
          className="prysm-badge-link">
          <img src={icon} alt={label} className="prysm-badge-icon" />
        </a>
        <span className="prysm-badge-label">{label}</span>
      </div>
    )
  }
}

function renderPrysmBadgeContent(product = {}) {
  return <PrysmBadgeComponent product={product} />
}

export { renderPrysmBadgeContent, FetchMysiteTranslationContent }
